import { Controller, useFormContext } from "react-hook-form";
import { Box } from "@mui/material";
import { StyledTextField } from "./StyleInputs";
import { parseNumber } from "utils/formUtils";

const TextareaField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const $errorMessage = errors[field.id]?.message;
  const customErrorMessage = field.validation?.errorMessage;
  const errorMessage = $errorMessage
    ? customErrorMessage || $errorMessage
    : undefined;

  return (
    <Box sx={{ mb: 3 }}>
      <Controller
        name={field.id}
        control={control}
        defaultValue=""
        rules={{
          ...(field?.validation?.min
            ? {
                minLength: parseNumber(field.validation.min),
              }
            : {}),
          ...(field?.validation?.max
            ? {
                maxLength: parseNumber(field.validation.max),
              }
            : {}),
          pattern: field.validation?.pattern
            ? {
                value: new RegExp(field.validation.pattern),
                message: field.validation.message || "Invalid format",
              }
            : undefined,
          required: field.required ? `${field.label} is required` : false,
        }}
        render={({ field: { onChange, value, ref } }) => (
          <StyledTextField
            fullWidth
            placeholder={field.placeholder}
            multiline
            rows={4}
            value={value}
            onChange={onChange}
            inputRef={ref}
            error={!!errorMessage}
            helperText={errorMessage}
            variant="outlined"
            required={field.required}
            label={field.label}
          />
        )}
      />
    </Box>
  );
};

export default TextareaField;
